import { FC, ReactElement } from 'react';

import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { HeaderNavigationCarousel } from '../headerNavigator/HeaderNavigationCarousel';

import styles from './TableTopConnected.module.css';

export const TableTopConnected: FC<{ componentMapTop: Record<string, ReactElement>; showStaticData?: boolean }> = ({
  componentMapTop,
  showStaticData = false,
}) => {
  const mods = useModifiers(
    styles,
    'tableTopContainer',
    {
      static: showStaticData,
    },
    { withBaseClass: true }
  );
  return (
    <div className={mods}>
      <HeaderNavigationCarousel
        calendarOptions={
          showStaticData ? ['Day', 'Month', 'Year'] : ['STATISTICS_DAY', 'STATISTICS_MONTH', 'STATISTICS_YEAR']
        }
        tabs={Object.keys(componentMapTop).map((tab) => ({
          label: showStaticData ? tab : <L10nText tk={tab} />,
          content: componentMapTop[tab],
          key: tab,
        }))}
        showStaticData={showStaticData}
      />
    </div>
  );
};
